import '/assets/styles/sections/web-menu-landing.scss';

import config from '@wearetla/tla-essentials-tools/config';
import { useMemo } from 'react';

// Partials
import Img from '@wearetla/tla-essentials-tools/partials/img';
import Btn from '/views/partials/btn';

// Context
import { useParams } from '@wearetla/tla-essentials-tools/utilities/navigator';
import { useModals } from '@wearetla/tla-essentials-tools/utilities/modals';
import { useTranslation } from '/utilities/i18n';

// Static Assets
import image_logo from '/assets/images/logo-white.svg';
import image_app_btn_apple_tr from '/assets/images/partials/app-links/btn-app-apple-tr.svg';
import image_app_btn_apple_en from '/assets/images/partials/app-links/btn-app-apple-en.svg';
import image_app_btn_google_tr from '/assets/images/partials/app-links/btn-app-google-tr.svg';
import image_app_btn_google_en from '/assets/images/partials/app-links/btn-app-google-en.svg';
import branchFeedbackFormIndex from '../../data/branch-feedback-form-index';
import { getLanguage } from '/data/languages';

const appBtnImages = {
	tr: { apple: image_app_btn_apple_tr, google: image_app_btn_google_tr },
	en: { apple: image_app_btn_apple_en, google: image_app_btn_google_en },
};

const WebMenuLanding = () => {
	const { branchSlug, tableId } = useParams('webMenuLanding');
	const { openModal } = useModals();
	const { language, t } = useTranslation();
	const appBtns = appBtnImages[language] ?? appBtnImages.tr;

	const feedbackUrl = useMemo(() => {
		return branchFeedbackFormIndex[branchSlug];
	}, [branchSlug]);

	return (
		<section className="section web-menu-landing">
			<Img src={image_logo} lazy={false} className="landing-logo" alt="IF Sokak" />

			<div className="landing-opts">
				<div className="opts-opt opts-menu">
					{!!branchSlug && (
						<Btn
							tag="link"
							href="webMenu"
							params={{
								branchSlug,
								tableId,
							}}
							icon="store"
							className="white big rounded"
						>
							{t('Menüye Git')}
						</Btn>
					)}
				</div>

				<div className="opts-opt opts-download">
					<strong className="download-title">
					{t('Mobil uygulamamızı indirerek hızlı ve sıra beklemeden sipariş verebilir, masaya getir özelliği ile yerinden kalkmadan siparişine ulaşabilirsin.')}
					</strong>
					<ul className="download-links">
						{!!config?.nativeApp?.appStoreLink && (
							<li className="links-link android">
								<Btn
									raw
									tag="link"
									target="_blank"
									rel="noopener noreferrer"
									className="link-btn block black rounded"
									href={config.nativeApp.appStoreLink}
								>
									<Img alt="Google Play Store" src={appBtns.apple} />
								</Btn>
							</li>
						)}
						{!!config?.nativeApp?.playStoreLink && (
							<li className="links-link ios">
								<Btn
									raw
									tag="link"
									target="_blank"
									rel="noopener noreferrer"
									className="link-btn block black rounded"
									href={config.nativeApp.playStoreLink}
								>
									<Img alt="App Store" src={appBtns.google} />
								</Btn>
							</li>
						)}
					</ul>
				</div>

				{feedbackUrl && (
					<div className="opts-opt opts-feedback">
						<Btn href={feedbackUrl} tag="link" className="nude hyperlink" raw>
							{t('Şikayet ve Öneri')}
						</Btn>
					</div>
				)}


			</div>

			<button
				type="button"
				className="landing-languagebtn"
				onClick={() => openModal('languages')}
			>
				{getLanguage(language)?.flag} {language.toUpperCase()}
			</button>
		</section>
	);
};

export default WebMenuLanding;
